var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOneClick3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 117,
    viewBox: "0 0 112 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_308_1249",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: -21,
    width: 127,
    height: 127
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.1103,
    cy: 42.1103,
    r: 63.0611,
    transform: "rotate(-78.7982 74.1103 42.1103)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_308_1249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.501397 329.048C53.8323 191.458 30.2905 28.0087 -66.2089 -63.1647",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66853 330.517C60.0023 192.927 52.6819 63.0067 -60.0389 -61.6952",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9371 331.46C67.2708 193.87 59.4675 61.3686 -52.7703 -60.7528",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0152 333.359C78.6108 174.248 50.8072 32.3195 -45.6922 -58.8539",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1021 335.158C83.4359 197.568 59.8941 34.1191 -36.6053 -57.0543",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8414 336.294C86.4548 201.147 71.3149 56.7566 -30.8661 -55.9183",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0142 337.714C96.348 200.124 79.2923 79.2095 -23.6932 -54.4982",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8043 338.563C108.455 206.747 78.1091 60.0904 -16.9031 -53.6498",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2613 338.548C106.599 186.003 94.0795 62.2592 -9.44609 -53.664",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4351 339.969C117.769 202.379 96.0237 53.698 -2.27228 -52.2438",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.605 350.103C166.207 183.644 153.039 70.7052 48.8976 -42.1095",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1304 341.294C124.464 203.704 100.922 40.2553 4.42302 -50.9181",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3 351.428C167.715 197.36 164.696 67.0495 55.593 -40.7841",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2594 342.905C132.593 205.315 109.051 41.8656 12.5519 -49.3078",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.43 353.038C175.627 185.011 169.692 79.469 63.7228 -39.1745",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4332 344.326C139.767 206.736 131.845 87.3812 19.7258 -47.8869",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.604 354.46C174.965 188.361 188.172 94.0642 70.8966 -37.7521",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.607 345.746C146.941 208.156 139.45 89.1351 26.8996 -46.4667",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.778 355.88C184.16 197.139 189.219 91.2891 78.0705 -36.3319",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.694 347.546C154.915 177.929 139.183 74.1735 35.9865 -44.6664",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.865 357.679C189.571 201.191 184.445 68.9723 87.1574 -34.5333",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.432 348.682C167.28 194.541 135.999 58.8811 41.7248 -43.5307",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.603 358.816C191.437 151.614 177.553 64.874 92.8957 -33.3969",
    stroke: "white",
    strokeOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneClick3);
export default __webpack_public_path__ + "static/media/one-click-3.ce2cc5ddd49e720d99da75f76a24abf1.svg";
export { ForwardRef as ReactComponent };